import {FC} from 'react';
import TruncateLeft from './TruncateLeft';
import TruncateMiddle from './TruncateMiddle';
import TruncateRight from './TruncateRight';
import {TruncatorProps} from './types';

const Truncator: FC<TruncatorProps> = ({
    truncateAt = 'right',
    ...restProps
}) => {
    if (truncateAt === 'left') return <TruncateLeft {...restProps} />;
    if (truncateAt === 'middle') return <TruncateMiddle {...restProps} />;
    if (truncateAt === 'right') return <TruncateRight {...restProps} />;

    return null;
};

export default Truncator;
